import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useApi } from "../../../shared/api";
import type { IUniformItemUpsertModel } from "../models/IUniformItemUpsertModel";

export const useUpsertUniformItem = () => {
  const { sport, organizationId } = useParams();
  const { mutateData } = useApi();

  return useMutation({
    mutationFn: async (upsertModel: IUniformItemUpsertModel) => {
      let url = `${sport}/o/${organizationId}/uniforms/${upsertModel.uniformId}/items`;
      if (upsertModel.uniformItemId) {
        url = `${sport}/o/${organizationId}/uniforms/items/${upsertModel.uniformItemId}`;
      }

      return await mutateData({
        url: url,
        method: upsertModel.uniformItemId ? "PUT" : "POST",
        data: upsertModel.upsertData,
      });
    },
  });
};
